import type { BadgeProps } from "@/components/ui/badge";

export type SeverityLevel = "critical" | "urgent" | "stable";

export interface SeverityMeta {
  level: SeverityLevel;
  label: string;
  variant: NonNullable<BadgeProps["variant"]>;
}

/** Dificultad 1-5 → severidad visual. */
export function difficultyToSeverity(difficulty: number): SeverityMeta {
  if (difficulty >= 4) return { level: "critical", label: "INMEDIATO", variant: "critical" };
  if (difficulty === 3) return { level: "urgent", label: "PRIORITARIO", variant: "urgent" };
  return { level: "stable", label: "PUEDE ESPERAR", variant: "stable" };
}

/** Mapea una especialidad a un ícono Lucide (string name). */
export function specialtyIcon(specialty: string): string {
  const map: Record<string, string> = {
    medicina_interna: "Stethoscope",
    cardiologia: "HeartPulse",
    urgencias: "Siren",
    pediatria: "Baby",
    cirugia: "Scissors",
    neurologia: "Brain",
    endocrinologia: "FlaskConical",
    nefrologia: "Droplets",
    gastroenterologia: "CircleDot",
    infectologia: "Bug",
    oncologia: "Target",
    psiquiatria: "BrainCircuit",
    medicina_familiar: "Users",
    geriatria: "User",
    hematologia: "Droplet",
    ginecologia_obstetricia: "Baby",
  };
  return map[specialty] ?? "Stethoscope";
}
